import { ReactNode } from 'react';
import { DrawerConfig } from '../../../../../containers/DocumentValidation/ValidationEmailDrawer';
import { Annotation } from '../../../../../types/annotation';
import { SidebarAction, SidebarActionBar } from '../../../../document-sidebar';
import { SidebarFooterActionIcon } from './SidebarFooterActionIcon';
import { useSidebarFooterActions } from './useSidebarFooterActions';

type SidebarFooterActionsProps = {
  annotation: Annotation;
  onEmailThreadOpen: (drawerConfig?: DrawerConfig) => void;
  children?: ReactNode;
};

export const SidebarFooterActions = ({
  annotation,
  onEmailThreadOpen,
  children,
}: SidebarFooterActionsProps) => {
  const {
    actions,
    postponeAndReject: { modal: postponeAndRejectModal },
    move: { modal: moveModal },
    link: { modal: linkModal },
    reExtract: { modal: reExtractModal },
    reAutomate: { modal: reAutomateModal },
  } = useSidebarFooterActions(annotation, onEmailThreadOpen);

  const mappedActions: SidebarAction[] = actions.map(action => ({
    id: action.id,
    label: action.label,
    icon: <SidebarFooterActionIcon actionId={action.id} fontSize="medium" />,
    onClick: action.onClick,
    disabled: action.disabled,
    dataCy: action.dataCy,
  }));

  return (
    <>
      <SidebarActionBar actions={mappedActions}>{children}</SidebarActionBar>
      {/* Modals and stuff, to be refactored */}
      {postponeAndRejectModal}
      {moveModal}
      {linkModal}
      {reExtractModal}
      {reAutomateModal}
    </>
  );
};
